export class RuntimeScheduler {
  private timer: number | null = null;

  constructor(private readonly callback: () => void, private readonly intervalMs: number) {}

  start(): void {
    if (this.timer !== null) {
      return;
    }
    this.timer = window.setInterval(() => {
      this.callback();
    }, this.intervalMs);
  }

  stop(): void {
    if (this.timer !== null) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }
}

